import styled from '@emotion/styled';
import React, { useState } from 'react'
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import { useTheme } from '@mui/styles';
import { Avatar, Box, Collapse, Divider, FormControlLabel, IconButton, List, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Menu, MenuItem, Toolbar, Tooltip, Typography } from '@mui/material';
import { AccountBalance, AccountCircle, Adb, Article, Assignment, AssignmentIndOutlined, ChevronLeft, ChevronRight, DoneAllOutlined, ExpandLess, ExpandMore, Home, Logout, ManageAccounts, MenuOutlined, People, Person, Sync } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import SwitchTheme from '../../../components/SwitchTheme';

const drawerWidth = 280;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const NavAdmin = (props) => {
    const theme = useTheme();
    // const [open, setOpen] = useState(true);
    const location = useLocation();
    const [isOpenState, setIsOpenState] = useState(true);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [usersOpen, setUsersOpen] = useState(false)

    const toggleDrawer = (state) => {
        setIsOpenState(state);
    };

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    }));

    console.log(props.mode);

    const handleUsersClick = () => {
        setUsersOpen(!usersOpen)
    }

    return (
        <>
            <Box sx={{ display: 'flex' }} mb={2}>
                {/* <CssBaseline /> */}
                <AppBar position="fixed" open={isOpenState}>
                    <Toolbar sx={{ background: theme.palette.breadcrumbsBg }}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => toggleDrawer(true)}
                            edge="start"
                            sx={{
                                marginRight: 5,
                                ...(isOpenState && { display: 'none' }),
                            }}
                        >
                            <MenuOutlined />
                        </IconButton>
                        <Adb sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
                        <Typography variant="h6" noWrap component="div">
                            WALLET
                        </Typography>
                        <Box sx={{ flexGrow: 1, bgcolor: "blue" }}>
                        </Box>
                        <Box sx={{ flexGrow: 0 }}>
                            <Tooltip title="Open settings">
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                                PaperProps={{
                                    elevation: 0,
                                    sx: {
                                        overflow: 'visible',
                                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                        mt: 1.5,
                                        '& .MuiAvatar-root': {
                                            width: 32,
                                            height: 32,
                                            ml: -0.5,
                                            mr: 1,
                                        },
                                        '&:before': {
                                            content: '""',
                                            display: 'block',
                                            position: 'absolute',
                                            top: 0,
                                            right: 14,
                                            width: 10,
                                            height: 10,
                                            bgcolor: 'background.paper',
                                            transform: 'translateY(-50%) rotate(45deg)',
                                            zIndex: 0,
                                        },
                                        width: '20ch',
                                    },
                                }}
                            >
                                <MenuItem onClick={handleCloseUserMenu}>
                                    <Avatar /> Profile
                                </MenuItem>
                                {/* <MenuItem onClick={handleCloseUserMenu}>
                                    <Avatar /> My account
                                </MenuItem> */}
                                <Divider />
                                <MenuItem>
                                    Theme <FormControlLabel control={<SwitchTheme sx={{ m: 1 }} onChange={() => props.setMode(props.mode === "light" ? "dark" : "light")} checked={props.mode === 'dark' ? true : false} />} label={props.mode === 'dark' ? "Dark" : "Light"}
                                    />
                                </MenuItem>
                                {/* <MenuItem onClick={handleCloseUserMenu}>
                                    <ListItemIcon>
                                        <Settings fontSize="small" />
                                    </ListItemIcon>
                                    Settings
                                </MenuItem> */}
                                <MenuItem onClick={props.onLogOut}>
                                    <ListItemIcon>
                                        <Logout fontSize="small" />
                                    </ListItemIcon>
                                    Logout
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </AppBar>
                <Drawer variant="permanent" open={isOpenState}>
                    <DrawerHeader>
                        <IconButton onClick={() => toggleDrawer(false)}>
                            {theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}
                        </IconButton>
                    </DrawerHeader>
                    <Divider />
                    <List>
                        <Tooltip title="Home" placement="right">
                            <ListItemButton to="/admin" component={Link} selected={"/admin" === location.pathname}>
                                <ListItemIcon>
                                    <Home />
                                </ListItemIcon>
                                <ListItemText primary="Home" />
                            </ListItemButton>
                        </Tooltip>
                        <Tooltip title="Validasi Dokumen" placement="right">
                            <ListItemButton
                                to="/admin/spm"
                                component={Link}
                                selected={
                                    "/admin/spm" === location.pathname ||
                                    "/admin/spm/periksa" === location.pathname ||
                                    "/admin/spm/periksa-acc" === location.pathname
                                }
                            >
                                <ListItemIcon>
                                    <Assignment />
                                </ListItemIcon>
                                <ListItemText primary="Validasi Dokumen" />
                            </ListItemButton>
                        </Tooltip>
                        {/* <Tooltip title="Acc" placement="right">
                            <ListItemButton to="/admin/acc" component={Link}
                                selected={
                                    "/admin/acc" === location.pathname ||
                                    "/admin/acc/periksa" === location.pathname
                                }>
                                <ListItemIcon>
                                    {<AssignmentTurnedIn />}
                                </ListItemIcon>
                                <ListItemText primary="Acc" />
                            </ListItemButton>
                        </Tooltip> */}
                        <Tooltip title="Proses SP2D" placement="right">
                            <ListItemButton to="/admin/proses_sp2d" component={Link}
                                selected={
                                    "/admin/proses_sp2d" === location.pathname ||
                                    "/admin/proses_sp2d/periksa" === location.pathname
                                }>
                                <ListItemIcon>
                                    {<Sync />}
                                </ListItemIcon>
                                <ListItemText primary="Proses SP2D" />
                            </ListItemButton>
                        </Tooltip>
                        {/* <Tooltip title="SP2D Ditandatangani" placement="right">
                            <ListItemButton to="/admin/sp2d_diserahkan" component={Link}
                                selected={
                                    "/admin/ttd_sp2d" === location.pathname
                                }>
                                <ListItemIcon>
                                    {<Sync />}
                                </ListItemIcon>
                                <ListItemText primary="SP2D Ditandatangani" />
                            </ListItemButton>
                        </Tooltip>
                        <Tooltip title="SP2D Diserahkan" placement="right">
                            <ListItemButton to="/admin/sp2d_diserahkan" component={Link}
                                selected={
                                    "/admin/sp2d_diserahkan" === location.pathname
                                }>
                                <ListItemIcon>
                                    {<Sync />}
                                </ListItemIcon>
                                <ListItemText primary="SP2D Diserahkan" />
                            </ListItemButton>
                        </Tooltip> */}
                        <Tooltip title="Selesai" placement="right">
                            <ListItemButton to="/admin/selesai" component={Link} selected={"/admin/selesai" === location.pathname}>
                                <ListItemIcon>
                                    {<DoneAllOutlined />}
                                </ListItemIcon>
                                <ListItemText primary="Selesai" />
                            </ListItemButton>
                        </Tooltip>
                        <Divider />
                        <Tooltip title="Kontrak" placement="right">
                            <ListItemButton to="/admin/kontrak" component={Link}
                                selected={
                                    "/admin/kontrak" === location.pathname ||
                                    "/admin/kontrak/detail" === location.pathname ||
                                    "/admin/kontrak/adendum-detail" === location.pathname
                                }
                            >
                                <ListItemIcon>
                                    {<AssignmentIndOutlined />}
                                </ListItemIcon>
                                <ListItemText primary="Kontrak" />
                            </ListItemButton>
                        </Tooltip>
                    </List>
                    <Divider />
                    <List
                        aria-labelledby="utility"
                        subheader={
                            <ListSubheader component="div" id="utility">
                                Utility
                            </ListSubheader>
                        }>
                        <Tooltip title="Users" placement="right">
                            <ListItemButton
                                onClick={handleUsersClick}
                                selected={
                                    "/admin/bendahara" === location.pathname ||
                                    "/admin/bendahara/add" === location.pathname ||
                                    "/admin/verifikator" === location.pathname ||
                                    "/admin/verifikator/add" === location.pathname
                                }
                            >
                                <ListItemIcon>
                                    <People /> {isOpenState ? "" : usersOpen ? <ExpandLess /> : <ExpandMore />}
                                </ListItemIcon>
                                <ListItemText primary="Users" />
                                {usersOpen ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                        </Tooltip>
                        <Collapse in={usersOpen} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <Tooltip title="Bendahara" placement="right">
                                    <ListItemButton
                                        sx={{ pl: isOpenState ? 4 : 2 }}
                                        to="/admin/bendahara"
                                        component={Link}
                                        selected={
                                            "/admin/bendahara" === location.pathname ||
                                            "/admin/bendahara/add" === location.pathname
                                        }>
                                        <ListItemIcon>
                                            <AccountCircle />
                                        </ListItemIcon>
                                        <ListItemText primary="Bendahara" />
                                    </ListItemButton>
                                </Tooltip>
                                <Tooltip title="Validator" placement="right">
                                    <ListItemButton
                                        sx={{ pl: isOpenState ? 4 : 2 }}
                                        to="/admin/verifikator"
                                        component={Link}
                                        selected={
                                            "/admin/verifikator" === location.pathname ||
                                            "/admin/verifikator/add" === location.pathname
                                        }
                                    >
                                        <ListItemIcon>
                                            <ManageAccounts />
                                        </ListItemIcon>
                                        <ListItemText primary="Validator" />
                                    </ListItemButton>
                                </Tooltip>
                            </List>
                        </Collapse>
                        <Tooltip title="Daftar OPD" placement="right">
                            <ListItemButton to="/admin/opd" component={Link} selected={"/admin/opd" === location.pathname}>
                                <ListItemIcon>
                                    {<AccountBalance />}
                                </ListItemIcon>
                                <ListItemText primary="Daftar OPD" />
                            </ListItemButton>
                        </Tooltip>
                        <Tooltip title="BUD" placement="right">
                            <ListItemButton to="/admin/bud" component={Link} selected={"/admin/bud" === location.pathname}>
                                <ListItemIcon>
                                    {<Person />}
                                </ListItemIcon>
                                <ListItemText primary="BUD & Kuasa BUD" />
                            </ListItemButton>
                        </Tooltip>
                        <Tooltip title="Kelengkapan" placement="right">
                            <ListItemButton to="/admin/kelengkapan" selected={"/admin/kelengkapan" === location.pathname} component={Link}>
                                <ListItemIcon>
                                    <Article />
                                </ListItemIcon>
                                <ListItemText primary="Kelengkapan" />
                            </ListItemButton>
                        </Tooltip>
                    </List>
                </Drawer>
                <Box component="main" sx={{ flexGrow: 1 }}>
                    <DrawerHeader />

                    {props.child}
                </Box>
            </Box>
        </>
    )
}

export default NavAdmin